// FAZ-10.6 / K-39 — curated lucide ikon adı → bileşen haritası. BE
// `ComponentIconNames.All` kapalı-kümesinin (51 ad) FE aynası. Her ikon AYRI
// named import (tree-shake'li; ana bundle'a yalnız kullanılan 51 ikon girer —
// `import * as lucide` yasak, tüm kütüphaneyi çeker).
//
// `icon` bloğu + `button.icon` bu haritadan render eder. Bilinmeyen ad → null
// (BE store-time zaten reddeder; bu render-güvenliği).

import type { LucideIcon } from 'lucide-react';
import {
  AlertCircle,
  ArrowLeft,
  ArrowRight,
  Award,
  Banknote,
  Briefcase,
  Building,
  Calendar,
  ChartBar,
  Check,
  ChevronDown,
  ChevronUp,
  Clock,
  CreditCard,
  Download,
  ExternalLink,
  FileText,
  Gift,
  Globe,
  HandCoins,
  Headset,
  Heart,
  Home,
  Info,
  Landmark,
  Layers,
  Lock,
  Mail,
  MapPin,
  MessageCircle,
  Minus,
  Percent,
  Phone,
  PiggyBank,
  Plus,
  RefreshCw,
  Search,
  Send,
  Settings,
  Shield,
  Smartphone,
  Star,
  Target,
  ThumbsUp,
  TrendingUp,
  Upload,
  User,
  Users,
  Wallet,
  X,
  Zap,
} from 'lucide-react';
import type { IconName } from './studioBlocks';

/** Kapalı-küme ikon adı → lucide bileşeni (adlar `studioBlocks.ICON_NAMES` ile birebir). */
export const ICON_COMPONENTS: Record<IconName, LucideIcon> = {
  check: Check,
  x: X,
  info: Info,
  'alert-circle': AlertCircle,
  phone: Phone,
  mail: Mail,
  'map-pin': MapPin,
  calendar: Calendar,
  clock: Clock,
  user: User,
  users: Users,
  home: Home,
  building: Building,
  'credit-card': CreditCard,
  wallet: Wallet,
  percent: Percent,
  'trending-up': TrendingUp,
  shield: Shield,
  lock: Lock,
  star: Star,
  heart: Heart,
  'arrow-right': ArrowRight,
  'arrow-left': ArrowLeft,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  plus: Plus,
  minus: Minus,
  search: Search,
  download: Download,
  upload: Upload,
  'file-text': FileText,
  globe: Globe,
  smartphone: Smartphone,
  banknote: Banknote,
  'piggy-bank': PiggyBank,
  'hand-coins': HandCoins,
  landmark: Landmark,
  briefcase: Briefcase,
  'chart-bar': ChartBar,
  gift: Gift,
  headset: Headset,
  'message-circle': MessageCircle,
  send: Send,
  'external-link': ExternalLink,
  refresh: RefreshCw,
  settings: Settings,
  'thumbs-up': ThumbsUp,
  award: Award,
  target: Target,
  zap: Zap,
  layers: Layers,
};
